export class Division {
  constructor(side, width, count, name, type, commander, attack, defence, startX, startY) {
    this.count = count;
    this.name = name;
    this.type = type;
    this.width = width;
    // this.divisionId = divisionId;
    this.commander = commander;
    this.attack = attack;
    this.defence = defence;
    this.side = side;

    this.startX = startX
    this.startY = startY
  }

  setDivisionId(divisionId) {
    this.divisionId = divisionId
    return this;
  }

  attachImage(imageUrl, minImgUrl) {
    this.imageUrl = imageUrl;
    this.minImgUrl = minImgUrl
    return this;
  }
}